import { __awaiter, __generator } from "tslib";
import { z } from 'zod';
function waitForRat(_a) {
    var _b, _c;
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure, timer = _a.timer, maxTimeOut = _a.maxTimeOut, _d = _a.onWaitFinish, onWaitFinish = _d === void 0 ? function () { } : _d;
    var isRatQueueEmpty = !((_c = (_b = window.RAL) === null || _b === void 0 ? void 0 : _b.callQueue) === null || _c === void 0 ? void 0 : _c.length);
    var isTimerFinished = timer > maxTimeOut;
    if (isRatQueueEmpty) {
        onSuccess({});
    }
    if (isTimerFinished) {
        onFailure();
    }
    if (isRatQueueEmpty || isTimerFinished) {
        onWaitFinish();
        return true;
    }
    return false;
}
export function waitForQueueToBeEmpty() {
    var timer = 0;
    var maxTimeOut = 5000;
    var interval = 500;
    return new Promise(function (resolve, reject) {
        var isResult = waitForRat({
            onSuccess: resolve,
            onFailure: reject,
            timer: timer,
            maxTimeOut: maxTimeOut,
        });
        if (isResult)
            return;
        var intervalID = setInterval(function () {
            waitForRat({
                onSuccess: resolve,
                onFailure: reject,
                timer: timer,
                maxTimeOut: maxTimeOut,
                onWaitFinish: function () { return window.clearInterval(intervalID); },
            });
            timer += interval;
        }, interval);
    });
}
export function getByIdentifier(key, result) {
    return result !== undefined && Array.isArray(result)
        ? result === null || result === void 0 ? void 0 : result.map(function (t) { return t === null || t === void 0 ? void 0 : t[key]; }).join(',')
        : undefined;
}
export function isRATAvailable() {
    return (typeof window !== 'undefined' &&
        !!window.RAT &&
        typeof window.RAT.addCustomEvent === 'function');
}
export function isValidURL(src) {
    return z.string().url().safeParse(src).success;
}
export function getUach() {
    return __awaiter(this, void 0, void 0, function () {
        var userAgentData, _a, architecture, bitness, fullVersionList, mobile, platformVersion, fullVersionListStr;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    userAgentData = window.navigator.userAgentData;
                    if (!userAgentData || !(userAgentData === null || userAgentData === void 0 ? void 0 : userAgentData.getHighEntropyValues)) {
                        return [2 /*return*/, {}];
                    }
                    return [4 /*yield*/, userAgentData.getHighEntropyValues([
                            'architecture',
                            'bitness',
                            'platformVersion',
                            'fullVersionList',
                        ])];
                case 1:
                    _a = _b.sent(), architecture = _a.architecture, bitness = _a.bitness, fullVersionList = _a.fullVersionList, mobile = _a.mobile, platformVersion = _a.platformVersion;
                    fullVersionListStr = fullVersionList === null || fullVersionList === void 0 ? void 0 : fullVersionList.map(function (v) { return "\"".concat(v.brand, "\";v=\"").concat(v.version, "\""); }).join(', ');
                    return [2 /*return*/, {
                            uach_arch: architecture,
                            uach_bitness: bitness,
                            uach_full_version_list: fullVersionListStr,
                            uach_platform_version: platformVersion,
                            uach_wow64: "".concat(mobile),
                        }];
            }
        });
    });
}
